import React from 'react';
import { getImageSourceFromProps } from '@shared/createEvent/utils/pixelImage';

type Props = {
  action: 'lead' | 'signup';
};

export const PixelImage: React.FC<Props> = props => {
  return <img src={getImageSourceFromProps(props)} alt={`conversion pixel - ${props.action}`} width="1" height="1" />;
};
